
import Home1 from "./Home1";
import Home2 from "./Home2";
import Home3 from "./Home3";
import Explore from "./Explore";
import About from "./About";
import Author from "./Author";
//import Profile from "./Profile";
//import EditProfile from "./EditProfile";
import EditProfileClient from "./EditProfile-Client";
import EditProfileFreelancer from "./EditProfile-Freelancer";
import Login from "./login";
import Register from "./register";
import Contact from "./Contact";
import B2cDashboard from "./B2cDashboard";
import Applicants from "./Applicants";
import ProjectProposal from "./ProjectProposal";
import ClientProjectManagement from "./ClientProjectManagement";
import ClientProjectArchive from "./ClientProjectArchive";
import FreelancerDashboard from "./FreelancerDashboard";
import ProjectDetail from "./ProjectDetail";
import BuyCoinClient from "./BuyCoinClient";
import BuyCoinFreelancer from "./BuyCoinFreelancer";
import FreelancerProjectManagement from "./FreelancerProjectManagement";
import FreelancerProjectArchive from "./FreelancerProjectArchive";
import ProjectDetailClient from "./ProjectDetailClient";
import EditProject from "./EditProject";
import DTTuningB2C from "./DTTUningb2c";
import BusinessType from "./BusinessType";
import 'bootstrap/dist/css/bootstrap.min.css';


const routes = [
  { path: '/', component: <Home1 /> },
  { path: '/home2', component: <Home2 /> },
  { path: '/home3', component: <Home3 /> },
  { path: '/explore', component: <Explore /> },
  { path: '/about', component: <About /> },
  { path: '/author', component: <Author /> },
  //{ path: '/profile', component: <Profile />},
  // { path: '/editProfile', component: <EditProfile />},
  { path: '/editProfile-client', component: <EditProfileClient /> },
  { path: '/editProfile-freelancer', component: <EditProfileFreelancer /> },
  { path: '/login', component: <Login /> },
  { path: '/register', component: <Register /> },
  { path: '/contact', component: <Contact /> },
  { path: '/dashboard-b2c', component: <B2cDashboard /> },
  { path: '/project-applicants', component: <Applicants /> },
  { path: '/project-proposal', component: <ProjectProposal /> },
  { path: '/client-project-management', component: <ClientProjectManagement /> },
  { path: '/client-project-archive', component: <ClientProjectArchive /> },
  { path: '/dashboard-freelancer', component: <FreelancerDashboard /> },
  { path: '/project-detail', component: <ProjectDetail /> },
  { path: '/buy-coin-client', component: <BuyCoinClient /> },
  { path: '/buy-coin-freelancer', component: <BuyCoinFreelancer /> },
  { path: '/freelancer-project-management', component: <FreelancerProjectManagement /> },
  { path: '/freelancer-project-archive', component: <FreelancerProjectArchive /> },
  { path: '/client-project-detail', component: <ProjectDetailClient /> },
  { path: '/client-edit-request', component: <EditProject /> },
  { path: '/business-type', component: <BusinessType /> },
  { path: '/dt-tuning/b2c', component: <DTTuningB2C /> },






]

export default routes;